export default __webpack_public_path__ + "static/media/bg-6.af3cab93.png";